import { BiCategoryAxisStyle, BiLabelRotate } from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleRow } from '../StyleRow';
import { StyleTextInput } from '../StyleTextInput';

const kRotations: BiLabelRotate[] = [0, 45, 90];

/** The category axis: shown, its title, how its labels turn. */
export const CategoryAxisFields = memo(
  ({
    name,
    axis,
    canRotate,
    onChange,
  }: {
    name: string;
    axis: BiCategoryAxisStyle;
    /** A horizontal bar's names read level down the side. */
    canRotate: boolean;
    onChange: (patch: Partial<BiCategoryAxisStyle>) => void;
  }) => (
    <>
      <StyleRow label={name}>
        <BiChip
          label="显示"
          selected={axis.show}
          onPress={() => onChange({ show: true })}
        />
        <BiChip
          label="隐藏"
          selected={!axis.show}
          onPress={() => onChange({ show: false })}
        />
      </StyleRow>
      {axis.show ? (
        <>
          <StyleRow label="标题">
            <StyleTextInput
              label={`${name}标题`}
              value={axis.label ?? ''}
              placeholder="不显示"
              onChange={text => onChange({ label: text || undefined })}
            />
          </StyleRow>
          {canRotate ? (
            <StyleRow label="标签角度">
              <BiChip
                label="自动"
                selected={axis.labelRotate === undefined}
                onPress={() => onChange({ labelRotate: undefined })}
              />
              {kRotations.map(rotate => (
                <BiChip
                  key={rotate}
                  label={`${rotate}°`}
                  selected={axis.labelRotate === rotate}
                  onPress={() => onChange({ labelRotate: rotate })}
                />
              ))}
            </StyleRow>
          ) : null}
        </>
      ) : null}
    </>
  ),
);
